import { render } from "./GroupPermissionsEdit.vue?vue&type=template&id=6eb1d51c"
import script from "./GroupPermissionsEdit.vue?vue&type=script&lang=js"
export * from "./GroupPermissionsEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__